<template>
  <div class="animated fadeIn">
    <basic-heading title="Sort Sample Types" class="mb-4">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <sortable-list
      v-if="sample_types && sample_types.length"
      :list="sample_types"
      groupBy="sample_types"
      keyField="id"
      labelField="name"
      @onOrderChange="onOrderChange"
    />
  </div>
</template>

<script>
import Vue from "vue";
import BasicHeading from "@/components/shared/BasicHeading";
import VueNotifications from "vue-notifications";
import { notificationOptions } from "@/shared/toast-notification-options";
import { sampleTypeNotifications } from "@/shared/notifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import SortableList from "@/components/shared/SortableList";

const SampleTypeRepository = LabRepositoryFactory.get("sampleType");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "SampleTypeSort",
  components: {
    SortableList,
    BasicHeading,
    HeaderButtonGroup,
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/sampletypes",
            title: "Sample type list",
          },
        ],
      };
    },
  },
  data() {
    return {
      move_init: false,
      sample_types: [],
    };
  },
  methods: {
    fetchSampleTypes() {
      return new Promise((resolve, reject) => {
        SampleTypeRepository.getAll()
          .then((response) => {
            if (response && response.status === 200 && response.data) {
              let data = [];
              for (let i in response.data) {
                let dm = response.data[i];
                let temp = {
                  name: dm.name || null,
                  description: dm.description || null,
                  id: dm.id || null,
                };
                data.push(temp);
              }
              resolve(data);
            } else {
              reject();
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    onOrderChange(sorted) {
      return new Promise((resolve, reject) => {
        SampleTypeRepository.sort(sorted)
          .then((response) => {
            if (response && response.status === 200 && response.data) {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  mounted() {
    this.fetchSampleTypes().then((sample_types) => {
      this.sample_types = sample_types;
    });
  },
  notifications: sampleTypeNotifications,
};
</script>
